.wrapper {
    display: block;
}

.label {
    &.checkbox {
        display: flex;
        margin: 1em 0;
        align-items: center;
        gap: 1em;

        .widgetWrapper {
            display: block;
            gap: 0;

            input {
                width: 1.5em;
                height: 1.5em;
            }
        }
    }
}

.labelText {
    text-transform: uppercase;
    white-space: nowrap;
}

.widgetWrapper {
    display: flex;
    gap: 1em;

    input,
    select,
    textarea {
        flex-grow: 1;
        width: 100%;
        padding: 0.5rem;
    }

    textarea {
        height: 20em;
    }
}

.error {
    color: var(--color-lobster);
}
